(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-tabbed-menu-drawer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    var drawer = document.querySelector('.custom-tabbed-drawer');
    if (!drawer) return;

    var tabs = drawer.querySelectorAll('.ctd-tab');
    var panels = drawer.querySelectorAll('.ctd-panel');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function (event) {
        event.preventDefault();
        var key = tab.getAttribute('data-ctd-tab');

        tabs.forEach(function (t) {
          t.classList.remove('ctd-tab--active');
          t.setAttribute('aria-selected', 'false');
        });
        tab.classList.add('ctd-tab--active');
        tab.setAttribute('aria-selected', 'true');

        panels.forEach(function (p) {
          p.classList.toggle('ctd-panel--active', p.getAttribute('data-ctd-panel') === key);
        });

        // Collapse every open row across all tabs on switch
        drawer.querySelectorAll('[data-ctd-row-open]').forEach(function (row) {
          row.removeAttribute('data-ctd-row-open');
          var btn = row.querySelector('[data-ctd-toggle]');
          if (btn) btn.setAttribute('aria-expanded', 'false');
        });
      });
    });

    drawer.querySelectorAll('[data-ctd-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        var row = btn.closest('[data-ctd-row]');
        var isOpen = row.hasAttribute('data-ctd-row-open');
        if (isOpen) {
          row.removeAttribute('data-ctd-row-open');
          btn.setAttribute('aria-expanded', 'false');
        } else {
          row.setAttribute('data-ctd-row-open', '');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
